import {
    GET_CATEGORIES,
    GET_CATEGORIES_PAGINATED,
    CATEGORY_ERROR,
    ADD_CATEGORY,
    DELETE_CATEGORY,
    GET_CATEGORY,
    UPDATE_CATEGORY
} from "../../actions/types";

const initalizeState = {
    categories: [],
    loading: true,
    updatedAt: new Date(),
    error: {}
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;

    switch (type) {
        // case GET_NON_PAGINATED_CATEGORIES:
        //   console.log("payload.rows=");
        //   console.log(payload)
        //   return Object.assign(
        //     {}, state, 
        //     {
        //       categories: payload.rows,
        //       loading: false,
        //     }
        //   );
        case GET_CATEGORIES:
          // console.log("GET_CATEGORIES payload=");
          // console.log(payload)
          return {
              ...state,
              categories: payload,
              loading: false,
          };

        case GET_CATEGORIES_PAGINATED:
          console.log("GET_CATEGORIES_PAGINATED payload=");
          console.log(payload)
          return {
              ...state,
              categoriesPaginated: payload.rows,
              loading: false,
          };

        case ADD_CATEGORY:
            return {
                ...state,
                categories: [payload, ...state.categories],
                loading: false,
                updatedAt: new Date(),
            };
        case DELETE_CATEGORY:
            return {
                ...state,
                categories: state.categories.filter(
                    category => category.id !== payload
                ),
                loading: false,
                updatedAt: new Date(),
            };
        case UPDATE_CATEGORY:
            let categories = state.categories;
            categories = categories.filter(category => {
                return category.id !== payload.id;
            });
            return {
                ...state,
                categories: [payload, ...categories],
                loading: false,
                updatedAt: new Date(),
            };
        case GET_CATEGORY:
            return {
                ...state,
                loading: false
            };
        case CATEGORY_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
